import React, { useState } from "react";
import Modal from "react-modal";
import CloseIcon from "../../assets/icons/close.svg";
import {
  getPharmacyTrainingVideo,
  getPrescriberTrainingVideo,
  getUserGuidePdf,
} from "../../shared/helpers";
import useRoles from "../../hooks/useRoles";

const GuideButtons = () => {
  const [showTrainingVideo, setShowTrainingVideo] = useState({
    status: false,
    url: "",
  });

  const handleOpenTrainingVideo = (url) => {
    if (typeof url === "string") setShowTrainingVideo({ status: true, url });
    else setShowTrainingVideo({ status: false, url: "" });
  };

  const {
    isHomecare,
    isOutpatient,
    isPrescriber,
    isPharmacy,
    isConnectedNurse,
  } = useRoles();

  const guideButtonClass =
    "w-70 min-w-[160px] cursor-pointer border-1 border-[#005B82] rounded-[500px] text-[#005B82] px-[25px] h-[56px] font-bold text-[18px] leading-[22px] transition-all duration-200 hover:bg-[#005B82] hover:text-white";

  return (
    <div className="mx-auto max-w-300" data-testid="auth-guide-buttons">
      <div className="mb-8 mt-8 flex flex-col items-stretch gap-4 md:flex-row md:gap-0">
        <div className="flex w-full  justify-center md:w-1/2 md:justify-end md:pr-2.5">
          <button
            className={guideButtonClass}
            onClick={() => window.open(getUserGuidePdf(), "_blank")}
            data-testid="auth-guide-user-guide-button"
          >
            User Guide
          </button>
        </div>

        <div className="flex w-full justify-center gap-5 md:w-1/2 md:justify-start md:pl-2.5">
          {isPrescriber && (
            <button
              className={guideButtonClass}
              onClick={() =>
                handleOpenTrainingVideo(getPrescriberTrainingVideo())
              }
              data-testid="auth-guide-prescriber-video-button"
            >
              Prescriber Training Video
            </button>
          )}
          {(isHomecare || isOutpatient || isPharmacy || isConnectedNurse) && (
            <button
              className={guideButtonClass}
              onClick={() => handleOpenTrainingVideo(getPharmacyTrainingVideo())}
              data-testid="auth-guide-pharmacy-video-button"
            >
              Pharmacy Training Video
            </button>
          )}
        </div>
      </div>

      <Modal
        isOpen={showTrainingVideo.status}
        style={customStyles}
        contentLabel="Session Expired Modal"
        overlayClassName="overlay-modal"
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false} // Added to clear the warning from tests
      >
        <div data-testid="auth-guide-video-modal">
          <button
            onClick={handleOpenTrainingVideo}
            className="close-icon-button "
            data-testid="auth-guide-video-close-button"
          >
            <img src={CloseIcon} alt="Close Icon" />
          </button>
          <div className="training-modal">
            <video
              width="500"
              height="300"
              autoPlay
              controls
              data-testid="auth-guide-video"
            >
              <source src={showTrainingVideo.url} type="video/mp4" />
            </video>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default GuideButtons;

let customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 630,
  },
};
